import { render, staticRenderFns } from "./DataPrivacy.vue?vue&type=template&id=ac5b33e0"
import script from "./DataPrivacy.vue?vue&type=script&lang=js"
export * from "./DataPrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports